<template>
    <div class="gh-page gh-page--mcd">
        <section class="gh-section">
            <div class="container">
                <h1 class="gh-section__heading">{{ documentData.heading }}</h1>
                <p>{{ leadingText }}</p>
            </div>
        </section>

        <section class="gh-section gh-section--form">
            <div class="container">
                <component :is="documentComponent" :event-type="eventType"></component>
            </div>
        </section>
    </div>
</template>

<script>
    import store from '@/modules/events/document/store';
    import documentMixin from '@/modules/events/document/mixins/document';

    export default {
        mixins: [documentMixin],

        components: {
            ghFormCertificate: () => import(/* webpackChunkName: "training" */ '@/modules/events/document/components/FormCertificate.vue'),
            ghFormInvoice: () => import(/* webpackChunkName: "training" */ '@/modules/events/document/components/FormInvoice.vue')
        },

        computed: {
            documentComponent() {
                return this.documentData.component
            },

            leadingText() {
                return `Thank you for enrolling in a Mental Health Academy Live Specialisation Course. ${this.documentData.helperText}`;
            },

            eventType() {
                return 'live-course'
            }
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (! vm.validType || ! vm.validDocument) {
                    vm.$router.replace('/');
                }
            });
        },

        created() {
            !this.$store.state.eventDocument && this.$store.registerModule('eventDocument', store);
        },
    }
</script>

<style lang="scss" scoped>
    .gh-section--form {
        padding-top: 0;
    }
</style>